<span #copiedToolTip id="myPopup" class="copiedTooltip">Copied to Clipboard!</span>
<div class="popup">
    <div class="data-div">
        <div id="elevation-container" class="measurement-container ">
            <span class="mat-font-title-md flex-grow-1" id="measure-elevation-name">{{relativePoint ? "Relative height" : "Elevation"}}</span>
            <div>
                <span class="measure-value" id="measure-elevation-value">{{elevation}}</span>
                <span class="measure-unit-value" id="measure-elevation-unit-value">{{elevationUnit}}</span>
                <app-copy-clipboard [message]="'Copied to clipboard'" [tooltipPosition]="'above'" [value]="getElevation()"></app-copy-clipboard>
            </div>
        </div>
        
        <div id="latitude-container" class="measurement-container">
            <span class="mat-font-title-md" id="measure-latitude-name">Lat/Long</span>
            <div >
                <span class="px-2 measure-value" id="measure-latitude-value">{{lat | number : '1.6-6'}}</span>
                <span class="px-2 measure-value" id="measure-longitude-value">{{lng | number : '1.6-6'}}</span>
                <app-copy-clipboard [message]="'Copied to clipboard'" [tooltipPosition]="'above'" [value]="getLocation()"></app-copy-clipboard>
            </div>
        </div>
    </div>
</div>
